// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__jd9H8","description":"Select_description__BqNas","select":"Select_select__aeuTF"};